import React from "react";
import { resolveImg } from "@/lib/api";
import { Reveal } from "./Reveal";

// Editorial page header used across interior pages.
export function PageHero({ eyebrow, title, intro, image }) {
  return (
    <section className="pt-36 lg:pt-48 pb-16 lg:pb-24 px-6 md:px-10 lg:px-14">
      <div className="max-w-[1500px] mx-auto grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          {eyebrow && <Reveal><div className="overline mb-6">{eyebrow}</div></Reveal>}
          <Reveal delay={80}>
            <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-espresso">
              {title}
            </h1>
          </Reveal>
        </div>
        {intro && (
          <Reveal delay={160} className="lg:col-span-5">
            <p className="text-lg lg:text-xl font-light leading-relaxed text-espressosoft/80">{intro}</p>
          </Reveal>
        )}
      </div>
      {image && (
        <Reveal delay={200} className="max-w-[1500px] mx-auto mt-14 lg:mt-20">
          <div className="overflow-hidden rounded-sm aspect-[16/8]">
            <img src={resolveImg(image)} alt={title} className="w-full h-full object-cover" loading="eager" />
          </div>
        </Reveal>
      )}
    </section>
  );
}
